import { colors } from '../../../../packages/colors';

// sx prop styles
export const sx = {
  root: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.indigo200,
  },
  // Main container with padding - holds left and right sections
  mainContainer: {
    display: 'flex',
    flexGrow: 1,
    height: '100vh',
    padding: '16px',
    gap: '16px',
    overflow: 'hidden',
  },
  // Left section container (header, nav, content, footer)
  leftSection: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minWidth: 0,
    backgroundColor: colors.white,
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.1)',
  },
  // Content wrapper inside left section (nav + content area)
  leftContentWrapper: {
    display: 'flex',
    flexGrow: 1,
    height: '100%',
    overflow: 'hidden',
  },
  // Main content area (where sections render)
  mainContent: {
    flexGrow: 1,
    padding: '24px',
    overflowY: 'auto',
  },
  // Footer with action buttons
  actionsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    padding: '16px 24px',
    borderTop: `1px solid ${colors.neutral100}`,
    backgroundColor: colors.white,
  },
  previousButton: {
    height: '44px !important',
    display: 'flex',
    padding: '12px !important',
    alignItems: 'center',
    gap: '4px',
    borderRadius: '6px !important',
    border: `1px solid ${colors.neutral300} !important`,
    background: `${colors.white} !important`,
    color: `${colors.neutral800} !important`,
    textAlign: 'right',
    fontFamily: 'Manrope',
    fontSize: '16px !important',
    fontStyle: 'normal',
    fontWeight: '700 !important',
    lineHeight: '20px !important',
    '&:hover': {
      backgroundColor: `${colors.white} !important`,
    },
  },
  nextButton: {
    height: '44px !important',
    padding: '12px !important',
    fontSize: '16px !important',
    fontWeight: '700 !important',
    borderRadius: '6px !important',
    lineHeight: '20px !important',
  },
  skipButton: {
    fontWeight: '600 !important',
    color: `${colors.neutral400} !important`,
    '&:hover': {
      color: `${colors.neutral500} !important`,
    },
  },
  // Right section container (recommendations, reasoning, etc)
  rightSection: {
    width: '400px',
    minWidth: '400px',
    maxWidth: '400px',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
  // Loading state
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100vw',
  },
  useAllRecommendationsButton: {
    display: 'flex',
    height: '40px !important',
    padding: '8px 16px !important',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '4px !important',
    border: `1px solid ${colors.primary300} !important`,
    background: `${colors.white} !important`,
    color: `${colors.primary600} !important`,
    fontSize: '14px !important',
    fontWeight: '600 !important',
    lineHeight: '20px !important',
    '&:hover': {
      backgroundColor: `${colors.primary50} !important`,
    },
  },
  subsectionTitle: {
    fontSize: '28px',
    fontWeight: 600,
    lineHeight: '36px',
    color: colors.neutral900,
  },
  subsectionDescription: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    color: colors.neutral600,
  },
  closeReasoning: {
    color: `${colors.primary600} !important`,
    fontWeight: '700 !important',
  },
};
